// @ts-nocheck
import {
  Palette,
  createTheme,
  TypographyVariantsOptions,
} from "@mui/material/styles";
import { FontStyle } from "@mui/material/styles/createTypography";

export const TextStyle: FontStyle = {
  fontFamily: '"Rubik", "Helvetica", "Arial", sans-serif',
  fontSize: 14,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 700,
  htmlFontSize: 16,
};

export const ProjectTextStyles = {
  explanation: {
    fontFamily: TextStyle.fontFamily,
    fontSize: `${0.8571428571428571}rem`,
    fontWeight: TextStyle.fontWeightLight,
    letterSpacing: "0.42px",
    color: "#185568",
  },
};

export const ProjectPalette: Palette = {
  tonalOffset: 0.2,
  background: { paper: "#fff", default: "#fafafa" },
  contrastThreshold: 3,
  grey: {
    "50": "#fafafa",
    "100": "#f5f5f5",
    "200": "#eeeeee",
    "300": "#e0e0e0",
    "400": "#bdbdbd",
    "500": "#9e9e9e",
    "600": "#757575",
    "700": "#616161",
    "800": "#424242",
    "900": "#a1a3a6",
    A700: "#616161",
    A100: "#d5d5d5",
    A400: "#303030",
    A200: "#aaaaaa",
  },
  text: {
    primary: "#222222",
    secondary: "#6f7173",
    disabled: "rgba(0, 0, 0, 0.38)",
  },
  divider: "rgba(0, 0, 0, 0.12)",
  primary: {
    main: "#868686",
    light: "#E1E1E1",
    dark: "#373737",
    contrastText: "#fff",
  },
  secondary: {
    main: "#25baa4",
    light: "rgb(80,199,182)",
    dark: "rgb(25, 130, 114)",
    contrastText: "#fff",
  },
  common: { black: "#000", white: "#fff" },
  error: {
    light: "#C20D00",
    main: "#C20D00",
    dark: "#C20D00",
    contrastText: "#fff",
  },
  mode: "light",
  action: {
    hoverOpacity: 0.08,
    hover: "rgba(0, 0, 0, 0.08)",
    selected: "rgba(0, 0, 0, 0.14)",
    disabledBackground: "rgba(0, 0, 0, 0.12)",
    disabled: "rgba(0, 0, 0, 0.26)",
    active: "rgba(0, 0, 0, 0.14)",
    selectedOpacity: 1,
    disabledOpacity: 0.08,
    focus: "rgba(0, 0, 0, 0.14)",
    focusOpacity: 1,
    activatedOpacity: 1,
  },
};

export const ProjectTypography: TypographyVariantsOptions = {
  h1: {
    fontFamily: TextStyle.fontFamily,
    fontSize: "9.6rem",
    fontWeight: TextStyle.fontWeightRegular,
    letterSpacing: "-0.5px",
    lineHeight: "11.376rem",
  },
  h2: {
    fontFamily: TextStyle.fontFamily,
    fontSize: "4.8rem",
    fontWeight: TextStyle.fontWeightRegular,
    lineHeight: "5.688",
  },
  h3: {
    fontFamily: TextStyle.fontFamily,
    fontSize: "4.2rem",
    fontWeight: TextStyle.fontWeightBold,
    lineHeight: "4.977",
    letterSpacing: "normal",
    fontStyle: "normal",
  },
  h4: {
    fontFamily: TextStyle.fontFamily,
    fontSize: "3.6rem",
    fontStyle: "normal",
    fontWeight: TextStyle.fontWeightRegular,
    letterSpacing: "0.3px",
    lineHEight: "4.3rem",
  },
  h5: {
    fontFamily: TextStyle.fontFamily,
    fontSize: "2.4rem",
    fontStyle: "normal",
    fontWeight: TextStyle.fontWeightBold,
    lineHeight: "2.8rem",
  },
  h6: {
    fontFamily: TextStyle.fontFamily,
    fontSize: "2.4rem",
    fontWeight: TextStyle.fontWeightRegular,
    fontStyle: "normal",
    lineHeight: "2.8rem",
    letterSpacing: "normal",
  },
  subtitle1: {
    fontFamily: TextStyle.fontFamily,
    fontSize: "1.8rem",
    fontWeight: TextStyle.fontWeightBold,
    fontStyle: "normal",
    lineHeight: "2.133rem",
    letterSpacing: "0.25px",
  },
  subtitle2: {
    fontFamily: TextStyle.fontFamily,
    fontSize: "1.8rem",
    fontWeight: TextStyle.fontWeightRegular,
    lineHeight: "2.1rem",
    fontStyle: "normal",
  },
  subtitle3: {
    fontFamily: TextStyle.fontFamily,
    fontSize: "18px",
    fontWeight: TextStyle.fontWeightRegular,
    lineHeight: "21px",
    fontStyle: "normal",
  },
  button: {
    textTransform: "uppercase",
    color: ProjectPalette.text.primary,
    fontFamily: TextStyle.fontFamily,
    fontSize: "1.8rem",
    fontWeight: TextStyle.fontWeightMedium,
    lineHeight: "2.1rem",
    fontStyle: "normal",
  },
  caption: {
    color: ProjectPalette.primary.light,
    fontFamily: TextStyle.fontFamily,
    lineHeight: "1.4rem",
    fontSize: "1.2rem",
    fontWeight: TextStyle.fontWeightBold,
    fontStyle: "normal",
  },
  body1: {
    color: ProjectPalette.text.primary,
    fontFamily: TextStyle.fontFamily,
    lineHeight: "2.8rem",
    fontSize: "1.8rem",
    letterSpacing: "0.5px",
    fontWeight: TextStyle.fontWeightRegular,
    fontStyle: "normal",
  },
  body2: {
    color: ProjectPalette.text.primary,
    fontFamily: TextStyle.fontFamily,
    lineHeight: "1.7rem",
    fontSize: "1.4rem",
    fontWeight: TextStyle.fontWeightRegular,
  },
  overline: {
    fontFamily: TextStyle.fontFamily,
    fontSize: "1.2rem",
    fontStyle: "normal",
    fontWeight: TextStyle.fontWeightRegular,
    lineHeight: "1.6rem",
  },
};

export default createTheme({
  breakpoints: {
    keys: ["xs", "sm", "md", "lg", "xl"],
    values: { xs: 0, lg: 1280, sm: 600, xl: 1920, md: 960 },
  },
  mixins: {
    toolbar: {
      minHeight: 56,
      "@media (min-width:0px) and (orientation: landscape)": { minHeight: 48 },
      "@media (min-width:600px)": { minHeight: 64 },
    },
  },
  shadows: [
    "none",
    "0px 1px 3px 0px rgba(0, 0, 0, 0.2),0px 1px 1px 0px rgba(0, 0, 0, 0.14),0px 2px 1px -1px rgba(0, 0, 0, 0.12)",
    "0px 1px 5px 0px rgba(0, 0, 0, 0.2),0px 2px 2px 0px rgba(0, 0, 0, 0.14),0px 3px 1px -2px rgba(0, 0, 0, 0.12)",
    "0px 1px 8px 0px rgba(0, 0, 0, 0.2),0px 3px 4px 0px rgba(0, 0, 0, 0.14),0px 3px 3px -2px rgba(0, 0, 0, 0.12)",
    "0px 2px 4px -1px rgba(0, 0, 0, 0.2),0px 4px 5px 0px rgba(0, 0, 0, 0.14),0px 1px 10px 0px rgba(0, 0, 0, 0.12)",
    "0px 3px 5px -1px rgba(0, 0, 0, 0.2),0px 5px 8px 0px rgba(0, 0, 0, 0.14),0px 1px 14px 0px rgba(0, 0, 0, 0.12)",
    "0px 3px 5px -1px rgba(0, 0, 0, 0.2),0px 6px 10px 0px rgba(0, 0, 0, 0.14),0px 1px 18px 0px rgba(0, 0, 0, 0.12)",
    "0px 4px 5px -2px rgba(0, 0, 0, 0.2),0px 7px 10px 1px rgba(0, 0, 0, 0.14),0px 2px 16px 1px rgba(0, 0, 0, 0.12)",
    "0px 5px 5px -3px rgba(0, 0, 0, 0.2),0px 8px 10px 1px rgba(0, 0, 0, 0.14),0px 3px 14px 2px rgba(0, 0, 0, 0.12)",
    "0px 5px 6px -3px rgba(0, 0, 0, 0.2),0px 9px 12px 1px rgba(0, 0, 0, 0.14),0px 3px 16px 2px rgba(0, 0, 0, 0.12)",
    "0px 6px 6px -3px rgba(0, 0, 0, 0.2),0px 10px 14px 1px rgba(0, 0, 0, 0.14),0px 4px 18px 3px rgba(0, 0, 0, 0.12)",
    "0px 6px 7px -4px rgba(0, 0, 0, 0.2),0px 11px 15px 1px rgba(0, 0, 0, 0.14),0px 4px 20px 3px rgba(0, 0, 0, 0.12)",
    "0px 7px 8px -4px rgba(0, 0, 0, 0.2),0px 12px 17px 2px rgba(0, 0, 0, 0.14),0px 5px 22px 4px rgba(0, 0, 0, 0.12)",
    "0px 7px 8px -4px rgba(0, 0, 0, 0.2),0px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px 4px rgba(0, 0, 0, 0.12)",
    "0px 7px 9px -4px rgba(0, 0, 0, 0.2),0px 14px 21px 2px rgba(0, 0, 0, 0.14),0px 5px 26px 4px rgba(0, 0, 0, 0.12)",
    "0px 8px 9px -5px rgba(0, 0, 0, 0.2),0px 15px 22px 2px rgba(0, 0, 0, 0.14),0px 6px 28px 5px rgba(0, 0, 0, 0.12)",
    "0px 8px 10px -5px rgba(0, 0, 0, 0.2),0px 16px 24px 2px rgba(0, 0, 0, 0.14),0px 6px 30px 5px rgba(0, 0, 0, 0.12)",
    "0px 8px 11px -5px rgba(0, 0, 0, 0.2),0px 17px 26px 2px rgba(0, 0, 0, 0.14),0px 6px 32px 5px rgba(0, 0, 0, 0.12)",
    "0px 9px 11px -5px rgba(0, 0, 0, 0.2),0px 18px 28px 2px rgba(0, 0, 0, 0.14),0px 7px 34px 6px rgba(0, 0, 0, 0.12)",
    "0px 9px 12px -6px rgba(0, 0, 0, 0.2),0px 19px 29px 2px rgba(0, 0, 0, 0.14),0px 7px 36px 6px rgba(0, 0, 0, 0.12)",
    "0px 10px 13px -6px rgba(0, 0, 0, 0.2),0px 20px 31px 3px rgba(0, 0, 0, 0.14),0px 8px 38px 7px rgba(0, 0, 0, 0.12)",
    "0px 10px 13px -6px rgba(0, 0, 0, 0.2),0px 21px 33px 3px rgba(0, 0, 0, 0.14),0px 8px 40px 7px rgba(0, 0, 0, 0.12)",
    "0px 10px 14px -6px rgba(0, 0, 0, 0.2),0px 22px 35px 3px rgba(0, 0, 0, 0.14),0px 8px 42px 7px rgba(0, 0, 0, 0.12)",
    "0px 11px 14px -7px rgba(0, 0, 0, 0.2),0px 23px 36px 3px rgba(0, 0, 0, 0.14),0px 9px 44px 8px rgba(0, 0, 0, 0.12)",
    "0px 11px 15px -7px rgba(0, 0, 0, 0.2),0px 24px 38px 3px rgba(0, 0, 0, 0.14),0px 9px 46px 8px rgba(0, 0, 0, 0.12)",
  ],
  direction: "ltr",
  typography: ProjectTypography,
  zIndex: {
    modal: 1300,
    snackbar: 1400,
    drawer: 1200,
    appBar: 1100,
    mobileStepper: 1000,
    tooltip: 1500,
  },
  shape: { borderRadius: 4 },
  spacing: 8,
  palette: ProjectPalette,
  components: {
    MuiSvgIcon: {
      styleOverrides: {
        fontSizeLarge: {
          fontSize: "3rem",
        },
      },
    },
  },
});
